module.exports = __webpack_public_path__ + "static/media/stone1_0.440b83be.png";